import React, { useMemo } from "react";
import { Avatar } from "antd";

const ReceivedMessageCell = ({ conversation }) => {

  // Ensure the message content is valid and a string
  const messageContent = useMemo(() => {
    return typeof conversation?.content === "object" &&
      conversation?.content?.messagetext
      ? conversation?.content?.messagetext
      : conversation?.content || conversation?.body || "Message not available";
  }, [conversation]);

  const formatMessageTime = (timestamp) => {
    const options = { 
      hour: '2-digit', 
      minute: '2-digit', 
      hour12: true // Ensures 12-hour format with AM/PM
    };
    return new Date(timestamp).toLocaleTimeString('en-US', options);
  };


  return (
    <div className={`gx-chat-item RM ${conversation?.sender_type === 'partner' ? "whatsapp" : "internal"}`}>

      <Avatar className="gx-size-40 gx-align-self-end" src={require("assets/images/avatar/user.jpg")} alt={conversation.name} />

      <div className="gx-bubble-block">
        <div className="gx-bubble">
          <div className="gx-message" style={{ fontSize: '15px' }}>{messageContent}</div>
          <div className="gx-time gx-text-muted gx-text-right gx-mt-2" style={{ fontSize: '10px', display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
            {conversation?.timestamp ? formatMessageTime(conversation.timestamp)
            : conversation?.created_at ? formatMessageTime(conversation.created_at)
            : "Time not available"}
          </div>
        </div>
      </div>

    </div>
  );
};

export default ReceivedMessageCell;
